'use client';

import {useState, useEffect} from 'react';
import {motion} from 'framer-motion';
import useTopStyle from 'utils/useTopStyle';
import BookBtn from '../buttons/BookBtn/BookBtn';
import ArrowLink from '../buttons/ArrowLink/ArrowLink';
import HeroDashboard from './HeroDashboard/HeroDashboard';
import heroVariants from 'animation/heroVariants';

const TypeWriter = ({messages = [], typingSpeed = 130, eraseSpeed = 50, pause = 900}) => {
  const [msgIndex, setMsgIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);
  const [display, setDisplay] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);
  const [cursorVisible, setCursorVisible] = useState(true);

  useEffect(() => {
    const id = setInterval(() => setCursorVisible(v => !v), 500);
    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    if (!messages || messages.length === 0) return;
    const current = messages[msgIndex] || '';
    if (!isDeleting) {
      if (charIndex < current.length) {
        const t = setTimeout(() => {
          setDisplay(current.slice(0, charIndex + 1));
          setCharIndex(c => c + 1);
        }, typingSpeed);
        return () => clearTimeout(t);
      } else {
        const t = setTimeout(() => setIsDeleting(true), pause);
        return () => clearTimeout(t);
      }
    } else {
      if (charIndex > 0) {
        const t = setTimeout(() => {
          setDisplay(current.slice(0, charIndex - 1));
          setCharIndex(c => c - 1);
        }, eraseSpeed);
        return () => clearTimeout(t);
      } else {
        setIsDeleting(false);
        setMsgIndex(i => (i + 1) % messages.length);
      }
    }
  }, [charIndex, isDeleting, msgIndex, messages, typingSpeed, eraseSpeed, pause]);

  return (
    <>
      {display}
      <span style={{
        display: 'inline-block',
        width: 2,
        marginLeft: 4,
        backgroundColor: 'currentColor',
        height: '0.85em',
        verticalAlign: 'text-bottom',
        visibility: cursorVisible ? 'visible' : 'hidden'
      }} />
    </>
  );
};

const HomeHero = (props) => {
  const ref = useTopStyle(72);
  const {title, titleAccent, titleMid, titleSuffix, text, highlight} = props;

  return (
    <motion.section
      className='home-hero'
      ref={ref}
      initial={'hidden'}
      animate={'visible'}
      transition={{duration: 0.7, delay: 0.5, ease: 'easeInOut'}}
      variants={heroVariants}
    >
      <div className='container'>
        <div className='content'>
          <h2 className='title'>
            {titleAccent ? (
              <>
                {title} <span className='title-accent'>{titleAccent}</span><br />
                {titleMid ? <>{titleMid} </> : null}
              </>
            ) : title}
            {highlight && (
              <span className='highlight'>
                <TypeWriter messages={Array.isArray(highlight) ? highlight : [highlight]} typingSpeed={60} eraseSpeed={30} pause={700} />
              </span>
            )}
            {titleSuffix && <span className='title-suffix'>{titleSuffix}</span>}
          </h2>

          <p className='text'>{text}</p>
          <div className='buttons'>
            <BookBtn />
            <ArrowLink text={"View the platform"} url={"platform/overview/"}/>
          </div>
        </div>
        <div className='design'>
          <HeroDashboard />
        </div>
      </div>
    </motion.section>
  );
};

export default HomeHero;
